module.exports = __webpack_public_path__ + "img/cover-promotion-bg.ddcd9ba5.jpg";